import N8nPopoverReka from './N8nPopoverReka.vue';

export default N8nPopoverReka;
